import { ApiResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";

const SERVICE_URL = ServiceEndPoint.account_service;


export async function fetchList(endPoint:string,payload:any): Promise<ApiResponse<any>>{
    const response = await axiosService.post(`${SERVICE_URL}${endPoint}`, payload);
    return response.data;
}